import React from 'react';
import DocumentToAccept from './DocumentToAccept';
import TermsOfUseInput from './TermsOfUseInput';

const UserTermsOfUsePendingRequest = ({ userTermsOfUsePendingChangeRequest }) => {
  return (
    <>
      {userTermsOfUsePendingChangeRequest.map((req) => (
        <div key={req.id}>
          <DocumentToAccept pendingChangeRequest={req} />
          <br />
          <TermsOfUseInput inputName="userTermsOfUseStatus" />
        </div>
      ))}
    </>
  );
};

export default UserTermsOfUsePendingRequest;
